module.exports = __webpack_public_path__ + "media/images/web_suite/dashboard/blog_icon-761a5bda8dca4c8a378e0bc7ebf58d0b.png";